export const throttle = <T extends (...args: any[]) => void>(
  fn: T,
  waitMs: number,
) => {
  let last = 0;
  let timer: number | null = null;
  let lastArgs: any[] | null = null;

  const run = () => {
    last = Date.now();
    timer = null;
    if (lastArgs) {
      fn(...(lastArgs as Parameters<T>));
      lastArgs = null;
    }
  };

  return (...args: Parameters<T>) => {
    const now = Date.now();
    const remaining = waitMs - (now - last);

    lastArgs = args;

    if (remaining <= 0) {
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
      run();
      return;
    }

    if (!timer) {
      timer = window.setTimeout(run, remaining);
    }
  };
};
